<script>
import MSelectPulldown from '@/components/MSelectPulldown/index.vue'
export default {
  components: {
    MSelectPulldown
  },
  props: {
    value: {
      type: [Number, String]
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    queryParams: {
      type: Object,
      required: false
    },
  },
  data() {
    return {
      localValue: this.value,
      page: {
        enabled: true,
        page: 1,
        size: 50,
        total: 0
      },
      field: {
        value: 'id',
        label: 'name'
      },
    };
  },
  watch: {
    value(newValue) {
      this.localValue = newValue
    }
  },
  methods: {
    onItemChecked(checkedItem) {
      this.$emit('input', checkedItem.id)
      let optionItem = {}
      if (checkedItem.id) {
        Object.assign(optionItem, {
          label: checkedItem.name,
          value: checkedItem.id,
          raw: checkedItem
        })
      }
      this.$emit('change', optionItem)
    },
    async loadData(keyword) {
      const { page, size } = this.page;
      const params = {
        ...this.queryParams,
        name: keyword,
        page,
        size,
        sort: ['commonly_used_port_flag,desc', 'id,asc']
      };
      const res = await this.$store.dispatch('bu_port/fetchOptions', params);
      let records = res.data.records || [];
      // 更新分页总数
      this.page.total = res.data.total;
      return {
        data: records
      };
    },
    onSearch(keyword) {
      console.log('onSearch', keyword)
    },
    async fetchObject(value) {
      return await this.$store.dispatch('bu_port/fetchObject', value);
    }
  }
}
</script>

<template>
  <m-select-pulldown
    ref="pulldown"
    v-model="localValue"
    :disabled="disabled"
    :clearable="clearable"
    :fetch-options="loadData"
    :fetch-object="fetchObject"
    :page="page"
    :field="field"
    :group="{ enabled: false }"
    :placeholder="placeholder"
    @checked="onItemChecked"
    @search="onSearch"
  >
    <template #content="{ list }">
      <div v-for="(item, index) in list" :key="index" class="item padding-sm cursor" :class="{ 'active': item.id === localValue }" @click="$refs.pulldown.onItemChecked(item)">
        <div class="flex justify-between">
          <div>
            <span class="text-bold" style="color: var(--color-text-1);">{{ item.name }}</span>
            <el-tag class="margin-left" v-if="item.commonlyUsedPortFlag === 1" type="primary">常用</el-tag>
          </div>
          <div>
            <span class="label">国家/地区：</span>
            <span>{{ item.country || '-' }}</span>
          </div>
        </div>
      </div>
    </template>
  </m-select-pulldown>
</template>

<style scoped lang="scss">
.item {
  background: var(--color-fill-2);
  border-radius: 4px;
  position: relative;
  overflow: hidden;

  &.active::after {
    content: '';
    position: absolute;
    top: -1.7em;
    left: -1.7em;
    width: 3.5em;
    height: 3.5em;
    transform: rotate(45deg);
    background: var(--color-success);
  }
  &.active::before {
    content: '◉';
    position: absolute;
    top: 0.2em;
    left: 0.2em;
    color: var(--color-white);
    z-index: 1;
  }

  & ~ & {
    margin-top: 12px;
  }
}
.label {
  font-size: 12px;
  color: var(--color-text-3);
}
</style>
